
import { Vue } from "vue-class-component";

export default class TopupLayout extends Vue {}
